import {ImageCropperComponent} from './ImageCropperComponent'
import './scss/imagecropper.scss'

const ImageCropperPackage = {
    name: 'UIImageCropper',
    configure: function(config) {
        config.addComponent('UIImageCropper', ImageCropperComponent, false, 'ImageCropperComponent')

        config.addLabel('Restore all', {
            sv: 'Återställ alla'
        })

        config.addLabel('Disable automatic crop in frontend', {
            sv: 'Använd inte automatisk crop vid utvisning'
        })

        config.addLabel('Crop', {
            sv: 'Beskär'
        })
    }
}

export {ImageCropperPackage}
